export default function parseInputValue(value) {
  if (typeof value === 'undefined') return value;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return value.toString();
  return value.join(',');
}